import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 32px;
  background-color: #f1f5fb;

  > * {
    width: 100%;
    max-width: 760px;
  }
`
